import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestBLOB, RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";
import isResponseValid from "libs/isResponseValid";
import Tr from "translations/Translations";

const PAPERS_GENERATOR_LIST_RESOURCE_ID = 'papersGeneratorList';

const getAvailablePapers = async (id) => {
    try {
        const res = await RestRequestGET(Endpoints.PAPERS_GENERATOR(id));

        reduxStore.dispatch(
            setResource(PAPERS_GENERATOR_LIST_RESOURCE_ID, res)
        )
    } catch (error) {
    }
}


const getRfxRequestPosition = async (id) => {
    return await RestRequestGET(Endpoints.RFX_REQUEST_POSITION(id));
}

const getSwzParams = async (id) => {
    return await RestRequestGET(Endpoints.SWZ_PARAMS(id));
}

const getRfxInvitedSupplierWithOffer = async (id) => {
    return await RestRequestGET(Endpoints.RFX_INVITED_SUPPLIER_WITH_OFFER(id));
}

const getRfxInvitedSupplierPosition = async (id, supplierId) => {
    return await RestRequestGET(Endpoints.RFX_INVITED_SUPPLIER_POSITION(id, supplierId));
}


const getSwzGeneratorParams = async (demandId) => {
    return await RestRequestGET(Endpoints.SIWZ_GET_GENERATOR_PARAMS(demandId));
}
const getRfxSupplierAttachmentsVerification = async (demandId, supplierId) => {
    return await RestRequestGET(Endpoints.GET_SUPPLIER_ATTACHMENTS_VERIFICATION(demandId, supplierId));
}

const downloadPaper = async (url, successCallback = () => {
}, errorCallback = () => {
}) => {
    try {
        RestRequestBLOB(url)
            .then(successCallback)
            .catch(errorCallback);
    } catch (error) {
    }
}

const sharePaperByUrl = async (url, shareSystem) => {
    const auth = JSON.parse(localStorage.getItem("authorize"));
    const params = {
        headers: {
            "CSRFToken": auth.csrf
        },
        params: {
            shareSystem
        }
    }
    try {
        const resp = await RestRequestPOST(url, null, params);
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return resp.success;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;
}



const sharePaper = async (id, paper, shareSystem) => {
    try {
        const auth = JSON.parse(localStorage.getItem("authorize"));
        const params = {
            headers: {
                "CSRFToken": auth.csrf
            }
        }
        const resp = await RestRequestPOST(Endpoints.PAPERS_GENERATOR_PRINT_SHARE(id, paper, shareSystem), null, params);
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return resp.success;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;
}

const loadLastShareHistory = async (id, paper) => {
    return await RestRequestGET(Endpoints.PAPERS_GENERATOR_PRINT_SHARE_HISTORY_LAST(id, paper));
}

const loadShareHistory = async (id, paper, system) => {
    return await RestRequestGET(Endpoints.PAPERS_GENERATOR_PRINT_SHARE_HISTORY(id, paper, system));
}

const clearResources = (resource) => reduxStore.dispatch(clearResource(resource));

export default {
    getAvailablePapers,
    clearResources,
    getRfxRequestPosition,
    getSwzParams,
    getRfxInvitedSupplierWithOffer,
    getRfxInvitedSupplierPosition,
    getRfxSupplierAttachmentsVerification,
    getSwzGeneratorParams,
    downloadPaper,
    sharePaper,
    sharePaperByUrl,
    loadLastShareHistory,
    loadShareHistory,
    PAPERS_GENERATOR_LIST_RESOURCE_ID
}